(function () {
  const SHELF_HANDLES = new Set([
    'tools-and-supplies',
    'brushes',
    'drills',
    'tweezers',
    'scribing-tools',
    'scratch-building',
    'adhesives',
    'nippers-and-knives',
    'sanding',
    'tapes',
    'markers',
    'paints',
    'panel-liners',
    'decals',
    'airbrush',
    'workshop-misc',
  ]);

  function shelfHandle() {
    const match = window.location.pathname.match(/\/collections\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  if (!SHELF_HANDLES.has(shelfHandle())) {
    return;
  }

  function compareSku(left, right) {
    return left.localeCompare(right, undefined, { numeric: true, sensitivity: 'base' });
  }

  function cancelScrollAnimations(grid) {
    grid.classList.add('scroll-trigger--cancel');

    grid.querySelectorAll('.scroll-trigger').forEach((element) => {
      element.classList.add('scroll-trigger--cancel');
      element.classList.remove('scroll-trigger--offscreen');
      element.style.removeProperty('--animation-order');
    });
  }

  function sortGridBySku() {
    const grid = document.getElementById('product-grid');
    if (!grid) {
      return;
    }

    const items = [...grid.querySelectorAll('.grid__item[data-ovs-sku]')];
    if (items.length < 2) {
      return;
    }

    cancelScrollAnimations(grid);

    items.sort((a, b) => {
      const skuA = (a.dataset.ovsSku || '').trim();
      const skuB = (b.dataset.ovsSku || '').trim();
      return compareSku(skuA, skuB);
    });

    const fragment = document.createDocumentFragment();
    items.forEach((item) => {
      fragment.appendChild(item);
    });
    grid.appendChild(fragment);
  }

  window.ovsSortToolsSuppliesBySku = sortGridBySku;

  document.addEventListener(
    'change',
    (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) {
        return;
      }

      if (target.closest('#main-collection-filters, .mobile-facets, .facets-wrapper')) {
        window.requestAnimationFrame(sortGridBySku);
      }
    },
    true,
  );

  window.addEventListener('popstate', () => {
    window.requestAnimationFrame(sortGridBySku);
  });
})();
